import { render, staticRenderFns } from "./C-1-2__CategoryInfo.vue?vue&type=template&id=07e909c8&"
import script from "./C-1-2__CategoryInfo.vue?vue&type=script&lang=js&"
export * from "./C-1-2__CategoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./C-1-2__CategoryInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
